import { Component } from '@angular/core';
import {NavbarComponent} from '../components/navbar/navbar.component';
import {NgIf} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-new-command',
  imports: [
    NavbarComponent,
    NgIf,
    MatIcon,
    RouterLink
  ],
  templateUrl: './new-command.component.html',
  styleUrl: './new-command.component.css'
})
export class NewCommandComponent {

}
